module.exports = __webpack_public_path__ + "cc98f8eed07459a385807aa11748ad93.MP3";